import React from 'react'
import {Route,Routes} from 'react-router-dom';
import ExerciseDetails from './pages/ExerciseDetails';
import Navbar from './component/Navbar';
import Home from './pages/Home';
import Footer from './component/Footer';
import Box from '@mui/material/Box';

const App = () => {
  return (
    <div>
      <Box width='400px' sx={{width:{xl:'1488px'}}}m='auto'>
      <Navbar/>
      <Routes>
        <Route path = '/' element={<Home/>}/>
        <Route path = '/exercise/:id' element={<ExerciseDetails/>}/>
      </Routes>
      <Footer/>
      </Box>
    </div>
  )
}

export default App